import { Klass } from "@pressmedia/webappbase";
import _setVal from "./_setVal";

export default {
	_setVal,
	
	async setVal(...args) {
		await this._promise;
		return this._setVal(...args);
	},
	
	clearVal() {
		Klass("VuwWysiwygField").parent.clearVal.apply(this, arguments);
		
		// clear history
		return this.clearHistory();
	},
	
	clearHistory() {
		!!this.quill && this.quill.history.clear();
		return this;
	},
	
	getHtmlVal() {
		return !this.quill ? "" : this.quill.root.innerHTML.replace(
			/\s*data-loaded="[^"]*"/g,
			""
		);
	},
	
	getTextVal() {
		return !this.quill ? "" : this.quill.getText();
	}
};
